import { api } from '@/helpers/api';

export default {
  async getHomeworks({ commit }, { studentId, payload }) {
    const responseHomeworks = await api.get(`parent/me/students/${studentId}/homeworks`, { params: payload });
    const responseIncoming = await api.get(`parent/me/students/${studentId}/homeworks/incoming`, { params: payload });

    const dataPastHomeworks = responseHomeworks.data.results;
    const filteredDataPastHomeworks = dataPastHomeworks
      .filter(homework => (homework.lesson.homeworkSubject || (homework.lesson.homeworkChecked && homework.status !== 0)));
    const dataIncoming = responseIncoming.data.results;
    const filteredIncomingHomeworks = dataIncoming.filter(homework => homework.homeworkSubject);

    const data = filteredDataPastHomeworks.concat(
      filteredIncomingHomeworks.map(lesson => ({ lesson })),
    );
    commit('setHomeworks', data);
  },

  clearHomeworks({ commit }) {
    commit('clearHomeworks');
  },
};
